module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kc-La.074b9cda.png";